<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectMobileCountryCode" });
import { t } from "svelte-i18n";
import { AutocompleteSingle } from "../../../../../selects/index.js";
import { COUNTRY_CODE } from "../../../../../common/environment.js";
import { COUNTRIES } from "../../../config/country-codes.js";
export let key;
export let isDisabled = false;
export let isRequired = false;
let countryCode = typeof key === "string" ? key : COUNTRY_CODE;
const addLabels = ({ code, phone }) => ({
    key: code,
    label: `${$t(`global.country.${code}`)} (+${phone})`
});
const onKeyChange = (key2) => {
    if (typeof key2 !== "string") {
        countryCode = COUNTRY_CODE;
    }
    const COUNTRY = COUNTRIES.find(({ phone }) => phone === key2);
    countryCode = COUNTRY === void 0 ? COUNTRY_CODE : COUNTRY.code;
};
const onCountryCodeChange = (countryCode2) => {
    const COUNTRY = COUNTRIES.find(({ code }) => code === countryCode2);
    key = COUNTRY === void 0 ? void 0 : COUNTRY.phone;
};
$: onKeyChange(key);
$: onCountryCodeChange(countryCode);
$: options = COUNTRIES.map(addLabels);
</script>

<AutocompleteSingle
    bind:key = { countryCode }
    label = 'Country Code'
    name = 'user.mobile.countryCode'
    placeholder = 'Country Code'
    { options }
    { isDisabled }
    { isRequired }
/>